module.exports = __webpack_public_path__ + "static/media/planPrev_1.78cc1363.png";